module.exports = __webpack_public_path__ + "img/library-releases.aa5a460f.png";